/** A canceled search may finish parsing even after transport cancellation. */
export async function loadSearchResponse<T>(query: string, limit: number, signal: AbortSignal): Promise<T | null> {
  if (signal.aborted) return null
  try {
    const response = await fetch(`/api/search?q=${encodeURIComponent(query)}&limit=${limit}`, { signal })
    if (!response.ok) throw new Error('Search request failed')
    const data = await response.json() as T
    return signal.aborted ? null : data
  } catch (error) {
    if (signal.aborted) return null
    throw error
  }
}
